import { useEffect, useState } from 'react';

const useMouseInside = (ref: React.RefObject<HTMLElement>): boolean => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (ref.current && ref.current.contains(event.target as Node)) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    };
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [ref]);

  return isActive;
};

export default useMouseInside;
